import type {
  AudienceFieldType,
  AudienceFilterInputType,
  AudienceMatchType,
  AudienceOpType,
} from "@/types/graphql/partner.generated";

/**
 * Фильтр из ответа сервера во вход мутации: без __typename, с nodeId.
 * Отдельный модуль: его берут graphMapping, nodeTypeTable и exitRulesForm,
 * так между ними нет цикла импорта.
 */
export const toFilterInput = (filter: {
  match: AudienceMatchType;
  conditions: {
    field: AudienceFieldType;
    op: AudienceOpType;
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValues?: string[] | null;
    nodeId?: string | null;
  }[];
}): AudienceFilterInputType => ({
  match: filter.match,
  conditions: filter.conditions.map((c) => ({
    field: c.field,
    op: c.op,
    boolValue: c.boolValue ?? null,
    numberValue: c.numberValue ?? null,
    stringValues: c.stringValues ?? null,
    nodeId: c.nodeId ?? null,
  })),
});
